module.exports = __webpack_public_path__ + "img/temp_created_mind.162510e2.svg";